import useViewModel from './ChargerSuggestionCard.viewmodel'
import DeviceSuggestionCard from '../DeviceSuggestionCard'

export type Props = Parameters<typeof useViewModel>[0]

const { SettingsSuggestions, SuggestionCard, SuggestionDescription } =
  DeviceSuggestionCard

export default function ChargerSuggestionCard(props: Props) {
  const viewModel = useViewModel(props)
  const {
    displayName,
    isLoadingOrIdle,
    settingPaths,
    limitsText,
    goalsDescriptions,
    articles,
    settingsWhitelist,
  } = viewModel

  if (isLoadingOrIdle) {
    return null
  }

  return (
    <DeviceSuggestionCard
      iconName="Zap"
      title={displayName}
      articles={articles}
    >
      {settingsWhitelist.length > 0 && (
        <SettingsSuggestions>
          {settingsWhitelist.includes('charge-limits') && (
            <SuggestionCard
              iconName="BatteryCharging"
              title="Charge limits"
              destinationPath={settingPaths.limits}
            >
              <SuggestionDescription>{limitsText}</SuggestionDescription>
            </SuggestionCard>
          )}
          {settingsWhitelist.includes('charge-goals') && (
            <SuggestionCard
              iconName="Target"
              title="Goals"
              destinationPath={settingPaths.goals}
            >
              <div className="flex flex-col">
                {goalsDescriptions.enabledPlans.length === 0 ? (
                  <SuggestionDescription>No goals set</SuggestionDescription>
                ) : (
                  <SuggestionDescription>Goals set</SuggestionDescription>
                )}
              </div>
            </SuggestionCard>
          )}
        </SettingsSuggestions>
      )}
    </DeviceSuggestionCard>
  )
}
